import { Button, createStyles, ListItemIcon, makeStyles, Typography } from '@material-ui/core';
import { Theme } from '@mui/material';
import React from 'react';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { ApiEntity } from '@backstage/catalog-model';
import { downloadJsonAsFile, downloadYamlAsFile } from '../../../../../components/file/file.download';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      paddingLeft: theme.spacing(1),
      textTransform: 'capitalize'
    }
  })
);

export const ButtonExportApi = (props: { apiDoc: ApiEntity }) => {

  const { apiDoc } = props;

  const classes = useStyles();

  const handleExport = () => {
    if (apiDoc.spec.definition?.startsWith('{')) {
      downloadJsonAsFile(`${apiDoc.metadata.name}-definition`, apiDoc.spec.definition);
    }
    else {
      downloadYamlAsFile(`${apiDoc.metadata.name}-definition`, apiDoc.spec.definition);	
    }
  };

  return (
    <ListItemIcon>
      <Button onClick={handleExport} title={`Export ${apiDoc.metadata.description} API definition.`}>
        <CloudDownloadIcon />
        <Typography className={classes.text}>Export</Typography>
      </Button>
    </ListItemIcon>
  );
}